import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatSalesOrderStatusLabel } from '#/modules/crmMgmt/salesOrder/helper/salesOrderStatus';

const SalesOrderStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatSalesOrderStatusLabel(status)}
    size={size}
    className={className}
  />
);

SalesOrderStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default SalesOrderStatusBadge;
